import defaultSource from "./defaultSource";
import normal from "./normal";

export default (function sourceRandomLogNormal(source) {
  function randomLogNormal() {
    var randomNormal = normal.source(source).apply(this, arguments);
    return function() {
      return Math.exp(randomNormal());
    };
  }

  randomLogNormal.source = sourceRandomLogNormal;

  return randomLogNormal;
})(defaultSource);



//////////////////
// WEBPACK FOOTER
// ./~/d3-random/src/logNormal.js
// module id = 1778
// module chunks = 3